import { BRAND } from './brand';

export const COLOR = {
  white: '#ffffff',
  danger: '#DB2622',
  warning: '#FAAD14',
  success: '#52C41A',

  /** Skyrise brand shortcuts */
  ink: BRAND.ink,
  electric: BRAND.electric,
  padilla: BRAND.padilla,
  lavanda: BRAND.lavanda,
  casa: BRAND.casa,
  hacienda: BRAND.hacienda,

  dust_red_1: '#FFF1F0',
  dust_red_2: '#FFCCC7',
  dust_red_4: '#FF7875',
  dust_red_8: '#A8071A',

  geek_blue_1: '#F0F5FF',
  geek_blue_3: '#ADC6FF',
  geek_blue_8: '#10239E',

  golden_purple_1: '#F9F0FF',
  golden_purple_3: '#D3ADF7',
  golden_purple_8: '#391085',

  sunset_orange_1: '#FFF7E6',
  sunset_orange_2: '#ffe7ba',
  sunset_orange_3: '#FFD591',
  sunset_orange_8: '#AD4E00',

  cyan_1: '#E6FFFB',
  cyan_3: '#87E8DE',
  cyan_8: '#006D75',

  polar_green_1: '#F6FFED',
  polar_green_3: '#B7EB8F',
  polar_green_8: '#237804',

  magenta_1: '#FFF0F6',
  magenta_3: '#FFADD2',
  magenta_8: '#9E1068',

  volcano_1: '#FFF2E8',
  volcano_8: '#AD2102',

  neutral_1: '#ffffff',
  neutral_2: '#FBFBFF',
  neutral_3: '#F7F7FA',
  neutral_4: '#f0f0f0',
  neutral_5: '#d9d9d9',
  neutral_6: '#bfbfbf',
  neutral_7: '#8c8c8c',
  neutral_8: '#595959',
  neutral_10: '#262626',
  neutral_11: '#1f1f1f',
  neutral_12: '#141414',
  neutral_13: '#000000',

  primary_1: '#F4F4FC',
  primary_2: '#E8E8F8',
  primary_3: BRAND.lavanda,
  primary_4: '#4a4fd4',
  primary_5: '#091563',
  primary_6: BRAND.electric,
  primary_7: '#091252',
  primary_8: '#080f48',
  primary_9: '#070d3e',
  primary_10: BRAND.ink,

  primary_font: BRAND.ink,

  title_85: 'rgba(10, 10, 54, 0.85)',

  content_bg: BRAND.ink,

  sider_bg: BRAND.siderBg,
  sider_border: BRAND.siderBorder,
  sider_text: BRAND.siderText,
  sider_text_muted: BRAND.siderTextMuted,
  sider_item_hover: BRAND.siderItemHover,
  sider_item_active: BRAND.siderItemActive,
  sider_submenu_bg: BRAND.siderSubmenuBg,
  sider_heading: BRAND.siderHeading,
  sider_accent: BRAND.siderAccent,

  black_10: 'rgba(0, 0, 0, 0.1)',
  black_50: 'rgba(0, 0, 0, 0.5)',

  placeholder_50: 'rgba(10, 10, 54, 0.45)',

  secondary_45: 'rgba(10, 10, 54, 0.35)',

  conditional_divider: 'rgba(10, 10, 54, 0.08)'
};

/** Destructive “Delete” labels (links, menu items, modal secondary actions). Matches Ant Design error token. */
export const DELETE_ACTION_COLOR = 'var(--ant-color-error)';
